import { BREAKPOINTS } from '../constants';
export default {
  data: function data() {
    return {
      $responsive_width: 0,
      $responsive_height: 0
    };
  },
  computed: {
    /*** BREAKPOINTS ***/
    $responsive_isMobileSmall: function $responsive_isMobileSmall() {
      return this.$data.$responsive_width < BREAKPOINTS.mobile;
    },
    $responsive_isMobile: function $responsive_isMobile() {
      return this.$data.$responsive_width >= BREAKPOINTS.mobile;
    },
    $responsive_isMobileLarge: function $responsive_isMobileLarge() {
      return this.$data.$responsive_width >= BREAKPOINTS.mobileLarge;
    },
    $responsive_isTablet: function $responsive_isTablet() {
      return this.$data.$responsive_width >= BREAKPOINTS.tablet;
    },
    $responsive_isTabletLarge: function $responsive_isTabletLarge() {
      return this.$data.$responsive_width >= BREAKPOINTS.tabletLarge;
    },
    $responsive_isDesktop: function $responsive_isDesktop() {
      return this.$data.$responsive_width >= BREAKPOINTS.desktop;
    },
    $responsive_isDesktopLarge: function $responsive_isDesktopLarge() {
      return this.$data.$responsive_width >= BREAKPOINTS.desktopLarge;
    },
    $responsive_isDesktopHuge: function $responsive_isDesktopHuge() {
      return this.$data.$responsive_width >= BREAKPOINTS.desktopHuge;
    }
  },
  methods: {
    $_responsive_onResize: function $_responsive_onResize() {
      this.$data.$responsive_width = window.innerWidth;
      this.$data.$responsive_height = window.innerHeight;
    }
  },
  created: function created() {
    this.$_responsive_onResize();
    window.addEventListener('resize', this.$_responsive_onResize, {
      passive: true
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.$_responsive_onResize, {
        passive: true
      });
    }
  }
};